const addressesKeys = {
  module: ['addresses'] as const,
  list: () => [...addressesKeys.module, 'list'] as const,
  listWithFilters: (filters: any) =>
    [...addressesKeys.list(), filters] as const,
  details: (id: string) => [...addressesKeys.module, 'details', id] as const,
  search: (search: string) =>
    [...addressesKeys.module, 'search', search] as const,
};

export default addressesKeys;
